import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
import { authApi } from '../../api/auth';
import { ApiError } from '../../api/client';
import { Spinner } from '../../components/ui/Card';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [state, setState] = useState<'pending' | 'ok' | 'fail'>('pending');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setState('fail');
      setMessage('No verification token provided');
      return;
    }
    authApi
      .verifyEmail(token)
      .then(() => {
        setState('ok');
        setMessage('Your email is verified.');
      })
      .catch((err) => {
        setState('fail');
        setMessage(err instanceof ApiError ? err.message : 'Verification failed');
      });
  }, [token]);

  return (
    <Card className="w-full max-w-md !p-8 text-center">
      <Link to="/" className="font-display font-bold text-2xl text-gradient inline-block">
        AltCoinsMoney
      </Link>
      <div className="mt-8">
        {state === 'pending' && (
          <>
            <Spinner size={32} />
            <div className="font-display text-xl mt-4">Verifying…</div>
          </>
        )}
        {state === 'ok' && (
          <>
            <div className="w-14 h-14 mx-auto rounded-full bg-success/10 text-success flex items-center justify-center text-3xl font-bold">
              ✓
            </div>
            <h1 className="font-display text-2xl font-bold mt-4">Email verified!</h1>
            <p className="text-ink-600 mt-2">{message}</p>
            <Link
              to="/auth/login"
              className="inline-block mt-6 text-violet-600 underline font-semibold"
            >
              Continue to login
            </Link>
          </>
        )}
        {state === 'fail' && (
          <>
            <div className="w-14 h-14 mx-auto rounded-full bg-danger/10 text-danger flex items-center justify-center text-3xl">
              ✗
            </div>
            <h1 className="font-display text-2xl font-bold mt-4">Verification failed</h1>
            <p className="text-ink-600 mt-2">{message}</p>
            <Link
              to="/auth/login"
              className="inline-block mt-6 text-violet-600 underline font-semibold"
            >
              Back to login
            </Link>
          </>
        )}
      </div>
    </Card>
  );
}
